module.exports = __webpack_public_path__ + "img/BASKET_552.bb53b278.png";